import "react-app-polyfill/ie11"; // For IE 11 support
import "react-app-polyfill/stable";
import "core-js";
import "./polyfill";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import store from "./store";
import ReactNotification from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import { icons } from "./assets/icons";
import { Provider } from "react-redux";

React.icons = icons;

ReactDOM.render(
  <Provider store={store}>
    <ReactNotification />
    <App />
  </Provider>,
  document.getElementById("root")
);
